import React, {ReactElement} from 'react';
import {FormattedMessage} from 'react-intl';
import {Link} from 'gatsby';
import {ReactComponent as AccountIcon} from '../../../images/icons/account.svg';
import LogoutButton from '../../DesignSystem/Buttons/Logout/LogoutButton';
import {ButtonVariant} from '../../DesignSystem/Buttons/Button/Button';
import RenderOnLocales from '../../../RenderOnLocales';
import {localesWithDashboard} from '../../../localeUtils/localisedFeatureFlags';
import {useLocale} from '../../../RootProvider/LocaleContext';
import {getPageRoute} from '../../../utils/routes/getPageRoute';

import './CurrentUserMenu.scss';

function CurrentUserMenu(): ReactElement {
  const locale = useLocale();
  return (
    <>
      <RenderOnLocales locales={localesWithDashboard}>
        <Link
          to={getPageRoute('dashboard.accountDetails', locale)}
          className="currentUserMenu__item unstyledLink"
          activeClassName="currentUserMenu__item--active"
        >
          <AccountIcon className="currentUserMenu__icon" />
          <FormattedMessage id="phoenix.nav.accountDetails.linkText" />
        </Link>
      </RenderOnLocales>
      <LogoutButton
        className="currentUserMenu__item"
        iconClassName="currentUserMenu__icon"
        buttonVariant={ButtonVariant.DEFAULT_TEXT}
        showIcon
      />
    </>
  );
}

export default CurrentUserMenu;
